import { TextInput } from '@frontend/components/basic-forms';
import { ActionModal } from '@frontend/components/modal';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { useImageModal } from './image-modal.controller';

export interface ImageModalData {
    src: string;
    alt: string;
}

export interface ImageModalProps {
    initialData: Partial<ImageModalData>;
    onConfirm(_data: ImageModalData): void;
    onCancel(): void;
}

export const ImageModal = (props: ImageModalProps) => {
    const viewProps = useImageModal(props);

    return (
        <ActionModal
            title={
                <FormattedMessage
                    id='content-detail.editor.image-modal.title'
                    description='Title for the modal used to insert an image in notification content'
                    defaultMessage='Insert image'
                />
            }
            cancel={{ onCancel: props.onCancel, label: CommonMessage.BUTTONS.CANCEL }}
            confirm={{
                onConfirm: () => props.onConfirm({ src: viewProps.src.trim(), alt: viewProps.alt.trim() }),
                label: CommonMessage.BUTTONS.CONFIRM,
                disabled: !viewProps.isValid
            }}>
            <div className='flex w-full flex-col gap-2'>
                <TextInput
                    label={
                        <FormattedMessage
                            id='content-detail.editor.image-modal.url'
                            description='Label for the image URL field in the notification content image modal'
                            defaultMessage='Image URL'
                        />
                    }
                    value={viewProps.src}
                    onChange={viewProps.setSrc}
                />
                <TextInput
                    label={
                        <FormattedMessage
                            id='content-detail.editor.image-modal.alt'
                            description='Label for the image alternative text field in the notification content image modal'
                            defaultMessage='Alternative text'
                        />
                    }
                    value={viewProps.alt}
                    onChange={viewProps.setAlt}
                />
            </div>
        </ActionModal>
    );
};
